import api from '@/app/endpoints.js';
import { POST } from '@/app/api/index';
import getShopDomain from '@/app/utils/getShopDomain';

/* --------------------------------  gfCount  6.9.2018 -------------------------------- */
(function (jQuery) {
  jQuery.gfCount = function (element, options) {
    const defaults = {};
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    let _storeCount = [];
    let _shop = '';
    let _isPushServer = false; // Check push server

    const _isCount = false; // False: Stop push to server

    const _countDomain = 'https://gem-count.herokuapp.com';

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      _shop = getShopDomain();
      if (_shop == '') {
        _shop = 'gempages.com';
      }

      _this.add('start', {});
      return false;
    };

    this.add = function (type, extra) {
      if (_isCount) {
        const block = extra;
        block.type = type;
        block.shop = _shop;
        _this.addToStore(block);

        // force push server;
        if (type == 'upgrade' || type == 'save' || type == 'run-publish' || type == 'yes-makedefault') {
          _this.pushServer();
        }
      }
    };

    this.addToStore = function (block) {
      _storeCount.push(block);
      if (_this.isMaxStore()) {
        _this.pushServer();
      }
    };

    this.isMaxStore = function () {
      if (_storeCount.length >= 20) {
        return true;
      } else {
        return false;
      }
    };

    this.pushServer = async function () {
      if (_isCount && _shop != 'gempages.com') {
        if (!_isPushServer) {
          try {
            _isPushServer = true;
            const data = {
              blocks: _storeCount,
            };
            const res = await POST(_countDomain + api.countBlocks().url, data);
            const jsonData = res.data;
            if (jsonData.success == true) {
              // Clear store count
              _storeCount = [];
            } else {
              // Server count not working
            }
            _isPushServer = false;
          } catch (error) {
            // Server count not working
            _isPushServer = false;
          }
        }
      }
    };

    this.init();
  };
  jQuery.fn.gfCount = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfcount')) {
        const plugin = new jQuery.gfCount(this, options);
        jQuery(this).data('gfcount', plugin);
      }
    });
  };
})(jQuery);
